import { Component } from 'react';
import { motion } from 'framer-motion';
import AsideMenu from '../components/admin/aside-menu';
import { menu } from './constants';

// Gets the display name of a JSX component for dev tools
export const getDisplayName = Component => Component.displayName || Component.name || 'Component';

export const withAdminLayout = WrappedComponent =>
	class extends Component {
		static displayName = `withAdminLayout(${getDisplayName(WrappedComponent)})`;

		static async getInitialProps(ctx) {
			const componentProps =
				WrappedComponent.getInitialProps && (await WrappedComponent.getInitialProps(ctx));

			return { ...componentProps };
		}

		render() {
			return (
				<div className="section">
					<div className="container">
						<div className="columns">
							<div className="column is-3">
								<AsideMenu menu={menu} />
							</div>
							<div className="column is-9">
								<WrappedComponent {...this.props} />
							</div>
						</div>
					</div>
				</div>
			);
		}
	};

const postVariants = {
	initial: { scale: 0.96, y: 30, opacity: 0 },
	enter: {
		scale: 1,
		y: 0,
		opacity: 1,
		transition: { duration: 0.5, ease: [0.48, 0.15, 0.25, 0.96] }
	},
	exit: {
		scale: 0.6,
		y: 100,
		opacity: 0,
		transition: { duration: 0.2, ease: [0.48, 0.15, 0.25, 0.96] }
	}
};

export const withAnimation = WrappedComponent =>
	class extends Component {
		static displayName = `withAnimation(${getDisplayName(WrappedComponent)})`;

		static async getInitialProps(ctx) {
			const componentProps =
				WrappedComponent.getInitialProps && (await WrappedComponent.getInitialProps(ctx));

			return { ...componentProps };
		}

		render() {
			return (
				<motion.div
					initial="initial"
					animate="enter"
					exit="exit"
					variants={{ exit: { transition: { staggerChildren: 0.1 } } }}>
					<motion.div variants={postVariants}>
						<WrappedComponent {...this.props} />
					</motion.div>
				</motion.div>
			);
		}
	};
